import { Component } from 'react';

/**
 * Catches render-time errors from the page tree so one throwing block shows a
 * fallback instead of blanking the whole document.
 *
 * `resetKey` must change on navigation (pass `router.asPath`) — without it the
 * boundary stays in its error state forever and one broken page poisons every
 * subsequent route.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught render error:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      this.props.fallback ?? (
        <div className="errorPage">
          <div className="l-grid">
            <div className="l-grid__col l-grid__col--l-8-12 l-grid__col--l-push-2-12">
              <h1 className="h3">Something went wrong</h1>
              <p>
                We couldn’t display this page. Please try again, or head back to
                the <a href="/">homepage</a>.
              </p>
            </div>
          </div>
        </div>
      )
    );
  }
}
